import { useQuery } from 'react-query';

import { getFilterItemOptionsByRowType as queryFn } from 'api/endPoints/getFilterItemOptionsByRowType';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetFilterItemOptionsByRowType = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getFilterItemOptions', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.rowType),
    });
};

interface QueryParams {
    rowType?: string;
}

export const FILTER_REFERENCES_TYPE_KEYS = {
    WBS: 'WBS',
    TAG: 'TAG',
    ACTIVITY_CODE: 'ACTIVITY_CODE',
    SEGMENT_NAME: 'SEGMENT_NAME',
    RESOURCE: 'RESOURCE',
    MANUAL: 'MANUAL',
} as const;

export type FilterReferenceKey = (typeof FILTER_REFERENCES_TYPE_KEYS)[keyof typeof FILTER_REFERENCES_TYPE_KEYS];

export interface QueryResponse {
    key: FilterReferenceKey;
    value: string;
}
